import React from 'react';

import './index.scss';
import { scrollTop } from 'utils';
import icon from 'assets/button-icon-left.svg';

const ClickOnlyButton = ({ label, onClick, isShowMark }) => {
   
  const onClickFunc = (e) => {
    scrollTop();
    onClick(e);
  };

  return (
    <div className="ClickOnlyButton">
      <button
        className="button"
        type="button"
        onClick={onClickFunc}
      >
        {label}
        {isShowMark ? <img className="nextImage" src={icon} alt="" /> : null}
      </button>
    </div>
  );
};

export default ClickOnlyButton;